import { useEffect, useRef } from 'react'

export type ImportMatchingChangesModalProps = {
  open: boolean
  changeCount: number
  onPriceOnly: () => void
  onAcceptAll: () => void
  onReview: () => void
  onDismiss: () => void
}

const matchingChangeNoun = (count: number): string => {
  const abs = Math.abs(count)
  const mod100 = abs % 100
  const mod10 = abs % 10
  if (mod100 > 10 && mod100 < 20) {
    return 'позиций'
  }
  if (mod10 === 1) {
    return 'позицию'
  }
  if (mod10 >= 2 && mod10 <= 4) {
    return 'позиции'
  }
  return 'позиций'
}

export const ImportMatchingChangesModal = ({
  open,
  changeCount,
  onPriceOnly,
  onAcceptAll,
  onReview,
  onDismiss,
}: ImportMatchingChangesModalProps) => {
  const dialogRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!open) {
      return
    }
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onDismiss()
      }
    }
    document.addEventListener('keydown', handleKeyDown)
    dialogRef.current?.focus()
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [open, onDismiss])

  if (!open) {
    return null
  }

  return (
    <div className="market-paywall-overlay" role="presentation" onClick={onDismiss}>
      <div
        ref={dialogRef}
        className="market-paywall-modal market-import-matching-modal"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="import-matching-changes-title"
        aria-describedby="import-matching-changes-message"
        tabIndex={-1}
        onClick={(event) => event.stopPropagation()}
      >
        <h2 id="import-matching-changes-title" className="market-paywall-modal__title">
          Правки при обновлении
        </h2>
        <p id="import-matching-changes-message" className="market-paywall-modal__message">
          Во время обновления мы внесли правки в {changeCount} {matchingChangeNoun(changeCount)}
        </p>
        <div className="market-paywall-modal__actions market-import-matching-modal__actions">
          <button type="button" className="echat-btn echat-btn--ghost" onClick={onPriceOnly}>
            Обновить только цены
          </button>
          <button type="button" className="echat-btn echat-btn--primary" onClick={onAcceptAll}>
            Принять все правки
          </button>
          <button type="button" className="echat-btn echat-btn--ghost" onClick={onReview}>
            Посмотреть изменения
          </button>
        </div>
      </div>
    </div>
  )
}
